module.exports = __webpack_public_path__ + "img/QA_banner.f73e3c3b.jpg";